export const OEM_ATK_SUB_FLAG = 'agentToolKit';

export const AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG = {
    aiGuideLocalization: 'enableAILocalization',
    aiGuideBuilder: 'enableGenerateAIGuideContent',
    aiAgentToolKit: OEM_ATK_SUB_FLAG,
};

export const OEM_AI_SUB_FLAGS = [
    AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG.aiGuideLocalization,
    AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG.aiGuideBuilder,
];
